import { VirtualKeyboardKeycap, VirtualKeyboardLayer, VirtualKeyboardLayout } from 'mathlive'

import { AppLanguage } from '~/types/locale'

const keyboardClassNames =
  '!bg-white !text-purple-ink [@media(hover:hover)]:hover:!bg-purple-light [&.is-pressed]:!bg-purple-medium [&.is-active]:!bg-purple-medium'
const actionClassNames =
  '!bg-purple-frost !text-purple-ink [@media(hover:hover)]:hover:!bg-purple-frost-mid [&.is-pressed]:!bg-purple-frost-deep [&.is-active]:!bg-purple-frost-deep'
const backspaceClassNames = '!bg-pink-logo !text-white [&.is-pressed]:!bg-pink-deep [&.is-active]:!bg-pink-deep'
const checkClassNames =
  '!bg-purple-royal !text-white [&.is-pressed]:!bg-purple-royal-dark [&.is-active]:!bg-purple-royal-dark'

const KEYCAPS: Record<string, Partial<VirtualKeyboardKeycap>> = {
  'variable-switch': {
    label: 'ABC',
    width: 1.5,
    command: ['switchKeyboardLayer', 'AlphabetLayer'],
    class: actionClassNames,
  },
  'veriable-number-switch': {
    label: '123',
    width: 1.5,
    command: ['switchKeyboardLayer', 'mainLayer'],
    class: actionClassNames,
  },
  '1': { label: '1', class: keyboardClassNames },
  '2': { label: '2', class: keyboardClassNames },
  '3': { label: '3', class: keyboardClassNames },
  '4': { label: '4', class: keyboardClassNames },
  '5': { label: '5', class: keyboardClassNames },
  '6': { label: '6', class: keyboardClassNames },
  '7': { label: '7', class: keyboardClassNames },
  '8': { label: '8', class: keyboardClassNames },
  '9': { label: '9', class: keyboardClassNames },
  '0': { label: '0', class: keyboardClassNames },
  '-': { label: '-', class: keyboardClassNames },
  '.': { label: '.', class: keyboardClassNames },
  '+': { label: '+', class: keyboardClassNames },
  '/': { label: '/', class: keyboardClassNames },
  '*': { label: '*', class: keyboardClassNames },
  '=': { label: '=', class: keyboardClassNames },
  '%': { label: '%', class: keyboardClassNames },
  ',': { label: ',', class: keyboardClassNames },
  '(': { label: '(', class: keyboardClassNames },
  ')': { label: ')', class: keyboardClassNames },
  a: { label: 'a', insert: '\\text{a}', shift: '\\text{A}', class: `text-2xl ${keyboardClassNames}` },
  b: { label: 'b', insert: '\\text{b}', shift: '\\text{B}', class: `text-2xl ${keyboardClassNames}` },
  c: { label: 'c', insert: '\\text{c}', shift: '\\text{C}', class: `text-2xl ${keyboardClassNames}` },
  d: { label: 'd', insert: '\\text{d}', shift: '\\text{D}', class: `text-2xl ${keyboardClassNames}` },
  e: { label: 'e', insert: '\\text{e}', shift: '\\text{E}', class: `text-2xl ${keyboardClassNames}` },
  f: { label: 'f', insert: '\\text{f}', shift: '\\text{F}', class: `text-2xl ${keyboardClassNames}` },
  g: { label: 'g', insert: '\\text{g}', shift: '\\text{G}', class: `text-2xl ${keyboardClassNames}` },
  h: { label: 'h', insert: '\\text{h}', shift: '\\text{H}', class: `text-2xl ${keyboardClassNames}` },
  i: { label: 'i', insert: '\\text{i}', shift: '\\text{I}', class: `text-2xl ${keyboardClassNames}` },
  j: { label: 'j', insert: '\\text{j}', shift: '\\text{J}', class: `text-2xl ${keyboardClassNames}` },
  k: { label: 'k', insert: '\\text{k}', shift: '\\text{K}', class: `text-2xl ${keyboardClassNames}` },
  l: { label: 'l', insert: '\\text{l}', shift: '\\text{L}', class: `text-2xl ${keyboardClassNames}` },
  m: { label: 'm', insert: '\\text{m}', shift: '\\text{M}', class: `text-2xl ${keyboardClassNames}` },
  n: { label: 'n', insert: '\\text{n}', shift: '\\text{N}', class: `text-2xl ${keyboardClassNames}` },
  o: { label: 'o', insert: '\\text{o}', shift: '\\text{O}', class: `text-2xl ${keyboardClassNames}` },
  p: { label: 'p', insert: '\\text{p}', shift: '\\text{P}', class: `text-2xl ${keyboardClassNames}` },
  q: { label: 'q', insert: '\\text{q}', shift: '\\text{Q}', class: `text-2xl ${keyboardClassNames}` },
  r: { label: 'r', insert: '\\text{r}', shift: '\\text{R}', class: `text-2xl ${keyboardClassNames}` },
  s: { label: 's', insert: '\\text{s}', shift: '\\text{S}', class: `text-2xl ${keyboardClassNames}` },
  t: { label: 't', insert: '\\text{t}', shift: '\\text{T}', class: `text-2xl ${keyboardClassNames}` },
  u: { label: 'u', insert: '\\text{u}', shift: '\\text{U}', class: `text-2xl ${keyboardClassNames}` },
  v: { label: 'v', insert: '\\text{v}', shift: '\\text{V}', class: `text-2xl ${keyboardClassNames}` },
  w: { label: 'w', insert: '\\text{w}', shift: '\\text{W}', class: `text-2xl ${keyboardClassNames}` },
  x: { label: 'x', insert: '\\text{x}', shift: '\\text{X}', class: `text-2xl ${keyboardClassNames}` },
  y: { label: 'y', insert: '\\text{y}', shift: '\\text{Y}', class: `text-2xl ${keyboardClassNames}` },
  z: { label: 'z', insert: '\\text{z}', shift: '\\text{Z}', class: `text-2xl ${keyboardClassNames}` },
  æ: { label: 'æ', insert: '\\text{æ}', shift: '\\text{Æ}', class: `text-2xl ${keyboardClassNames}` },
  ø: { label: 'ø', insert: '\\text{ø}', shift: '\\text{Ø}', class: `text-2xl ${keyboardClassNames}` },
  å: { label: 'å', insert: '\\text{å}', shift: '\\text{Å}', class: `text-2xl ${keyboardClassNames}` },
  normalA: { label: 'a', insert: 'a', shift: 'A', class: keyboardClassNames }, // Normal 'a'
  normalB: { label: 'b', insert: 'b', shift: 'B', class: keyboardClassNames }, // Normal 'b'
  normalC: { label: 'c', insert: 'c', shift: 'C', class: keyboardClassNames }, // Normal 'c'
  normalD: { label: 'd', insert: 'd', shift: 'D', class: keyboardClassNames }, // Normal 'd'
  normalE: { label: 'e', insert: 'e', shift: 'E', class: keyboardClassNames }, // Normal 'e'
  normalI: { label: 'i', insert: 'i', shift: 'I', class: keyboardClassNames }, // Normal 'i'
  normalX: { label: 'x', insert: 'x', shift: 'X', class: keyboardClassNames }, // Normal 'x'
  normalY: { label: 'y', insert: 'y', shift: 'Y', class: keyboardClassNames }, // Normal 'y'
  normalZ: { label: 'z', insert: 'z', shift: 'Z', class: keyboardClassNames }, // Normal 'z'
  // Template slots: #@ grabs the selection or the atom before the cursor (implicit argument),
  // #0 takes just the selection, #? drops in an empty placeholder. Only use #@ where pulling
  // in the preceding atom is the point (base of a power, numerator of a fraction) — in an
  // empty slot it swallows what the user just typed (4 then √ became √4 instead of 4√▢).
  square: { latex: '#@^2', class: keyboardClassNames }, // Square
  power: { latex: '#@^{#?}', class: keyboardClassNames }, // Power
  squareRoot: { latex: '\\sqrt{#0}', class: keyboardClassNames }, // Square root
  nthRoot: { latex: '\\sqrt[#0]{#?}', class: keyboardClassNames }, // nth root
  powerAndSqrtOfa: { latex: '\\sqrt[#0]a', class: keyboardClassNames }, // Power and square root of 'a'
  fraction: { latex: '\\frac{#@}{#?}', class: keyboardClassNames }, // Fraction
  parenthesisOf: { latex: '(#0)', class: keyboardClassNames }, // Parenthesis of something
  halfSeparator: { label: '[separator]', width: 0.5 },
  separator: { label: '[separator]', width: 1 },
  doubleSeparator: { label: '[separator]', width: 2 },
  maxSeprator: { label: '[separator]', width: 5 }, // Separator
  backspace: { label: '[backspace]', shift: undefined, class: backspaceClassNames, width: 1.5 }, // Backspace
  backspaceSmall: { label: '[backspace]', shift: undefined, class: backspaceClassNames, width: 1 },
  return: { label: '[return]', shift: undefined, class: actionClassNames, width: 1 },
  left: { label: '←', command: ['moveToPreviousChar'], class: actionClassNames },
  right: { label: '→', command: ['moveToNextChar'], class: actionClassNames },
  newLine: {
    label: '[return]',
    shift: undefined,
    width: 1,
    command: ['insert', '\\\\'],
    class: actionClassNames,
  }, // New line
  times: { label: '×', insert: '\\times', class: keyboardClassNames }, // Multiplication sign
  divide: { label: '÷', insert: '\\div', class: keyboardClassNames }, // Division sign
  log: { label: 'log', insert: '\\log', class: keyboardClassNames }, // Logarithm
  sin: { label: 'sin', insert: '\\sin', class: keyboardClassNames }, // Sine
  cos: { label: 'cos', insert: '\\cos', class: keyboardClassNames }, // Cosine
  absoluteValue: { latex: '\\left|#@\\right|', class: keyboardClassNames }, // Absolute value
  lessThan: { label: '<', insert: '<', class: keyboardClassNames }, // Less than
  lessEqual: { label: '≤', insert: '\\leq', class: keyboardClassNames }, // Less equal
  greaterThan: { label: '>', insert: '>', class: keyboardClassNames }, // Greater than
  greaterEqual: { label: '≥', insert: '\\geq', class: keyboardClassNames }, // Greater equal
  colon: { label: ':', insert: ':', class: keyboardClassNames }, // Ratio
  space: { label: '', latex: '\\enspace', width: 5, class: keyboardClassNames }, // Space
  parenOpen: { label: '(', insert: '(', class: keyboardClassNames },
  parenClose: { label: ')', insert: ')', class: keyboardClassNames },
  undo: { label: '↩', command: 'undo', shift: undefined, class: keyboardClassNames },
  redo: { label: '↪', command: 'redo', shift: undefined, class: keyboardClassNames },
  pi: { latex: '\\pi', class: keyboardClassNames },
  plusMinus: { latex: '\\pm', class: keyboardClassNames },
} as const

// Spacer only; the visible divider is one continuous line drawn by the grid styles in inAppKeyboard.module.css.
const columnBorderSeparator: Partial<VirtualKeyboardKeycap> = {
  label: '',
  width: 0.5,
  class: 'pointer-events-none !w-px !bg-transparent !my-0 !mx-0.5',
}

const numericRow = [
  KEYCAPS['1'],
  KEYCAPS['2'],
  KEYCAPS['3'],
  KEYCAPS['4'],
  KEYCAPS['5'],
  KEYCAPS['6'],
  KEYCAPS['7'],
  KEYCAPS['8'],
  KEYCAPS['9'],
  KEYCAPS['0'],
]

const variableRow = [
  KEYCAPS['normalA'],
  KEYCAPS['normalB'],
  KEYCAPS['normalC'],
  KEYCAPS['normalD'],
  KEYCAPS['normalE'],
  KEYCAPS['normalI'],
  KEYCAPS['normalX'],
  KEYCAPS['normalY'],
  KEYCAPS['normalZ'],
  KEYCAPS.backspaceSmall,
]

const commandRow = [
  KEYCAPS['+'],
  KEYCAPS['-'],
  KEYCAPS['.'],
  KEYCAPS[','],
  KEYCAPS.doubleSeparator,
  KEYCAPS['left'],
  KEYCAPS['right'],
  KEYCAPS['return'],
]

const HoMCompact_keyboard = (): Readonly<VirtualKeyboardLayout> => {
  return {
    label: 'CompactKeyboard',
    rows: [numericRow, variableRow, commandRow],
  }
}

const numpadKeycapClassNames = 'hide-shift !font-medium'
const numpadKey = (keycap: Partial<VirtualKeyboardKeycap>): Partial<VirtualKeyboardKeycap> => ({
  ...keycap,
  class: `${numpadKeycapClassNames} ${keycap.class ?? ''}`,
})

const DIVIDER_WIDTH = 5

interface NumpadGrid {
  id?: string
  rows: number
  columns: number
  divider: boolean
  plateWidth?: number
}

const numpadLayerStyle = ({ id = 'numpadLayer', rows, columns, divider, plateWidth }: NumpadGrid): string => {
  const edge = 20 + (divider ? DIVIDER_WIDTH : 0)
  const widthVars = plateWidth
    ? `
    --numpad-column-width: calc(${plateWidth - edge}px / ${columns});
    --numpad-keycap-width: calc(${plateWidth - edge}px / ${columns} - 4px);`
    : ''
  const vars = `
    --numpad-rows: ${rows};
    --numpad-columns: ${columns};
    --numpad-edge: ${edge}px;${widthVars}
    --numpad-divider-display: ${divider ? 'block' : 'none'};`
  return `
  #${id} {${vars}
  }
  body:has(#${id}.is-visible) {${vars}
  }
`
}

const checkLabel = (locale: AppLanguage): string => (locale === AppLanguage.NO ? 'Sjekk' : 'Check')
const numpadGridRow = (keys: Array<Partial<VirtualKeyboardKeycap>>): Array<Partial<VirtualKeyboardKeycap>> =>
  keys.map((keycap) =>
    keycap.label === '[separator]' ? { ...keycap, class: 'pointer-events-none !bg-transparent' } : numpadKey(keycap),
  )

// check-key: hidden on desktop by inAppKeyboardGrid.css - the activity card shows its own Check button there.
const checkKeycap = (locale: AppLanguage, sizeClassNames = ''): Partial<VirtualKeyboardKeycap> => ({
  label: checkLabel(locale),
  command: ['performWithFeedback', 'commit'],
  shift: undefined,
  class: `check-key ${checkClassNames} ${sizeClassNames} !text-13px !font-semibold`,
})
const checkKey = (locale: AppLanguage, sizeClassNames: string): Partial<VirtualKeyboardKeycap> =>
  numpadKey(checkKeycap(locale, sizeClassNames))

const alphabetLetters = (letters: string): Array<Partial<VirtualKeyboardKeycap>> =>
  [...letters].map((letter) => ({ ...KEYCAPS[letter], class: keyboardClassNames }))

const shiftKey: Partial<VirtualKeyboardKeycap> = { label: '[shift]', width: 1, class: `shift ${actionClassNames}` }
const numberSwitchKey = (targetLayer = 'numpadLayer'): Partial<VirtualKeyboardKeycap> => ({
  ...KEYCAPS['veriable-number-switch'],
  width: 1,
  command: ['switchKeyboardLayer', targetLayer],
  class: actionClassNames,
})
const spaceKey: Partial<VirtualKeyboardKeycap> = {
  ...KEYCAPS.space,
  label: 'SPACE',
  width: 5,
  class: `key-space ${actionClassNames}`,
}

const alphabetRows = (locale: AppLanguage): Array<Array<Partial<VirtualKeyboardKeycap>>> => {
  const isNorwegian = locale === AppLanguage.NO
  return [
    alphabetLetters(isNorwegian ? 'qwertyuiopå' : 'qwertyuiop'),
    alphabetLetters(isNorwegian ? 'asdfghjkløæ' : 'asdfghjkl'),
    [shiftKey, ...alphabetLetters('zxcvbnm'), KEYCAPS.backspaceSmall],
  ]
}

const ALPHABET_ROWS = 4
const alphabetLayer = (
  locale: AppLanguage,
  bottomRow: Array<Partial<VirtualKeyboardKeycap>>,
): VirtualKeyboardLayer => ({
  id: 'AlphabetLayer',
  style: numpadLayerStyle({
    id: 'AlphabetLayer',
    rows: ALPHABET_ROWS,
    columns: locale === AppLanguage.NO ? 11 : 10,
    divider: false,
    plateWidth: 520,
  }),
  rows: [...alphabetRows(locale), bottomRow].map(numpadGridRow),
})

const panelAlphabetBottomRow = (targetLayer: string): Array<Partial<VirtualKeyboardKeycap>> => [
  numberSwitchKey(targetLayer),
  spaceKey,
  KEYCAPS.return,
]
const testPrepAlphabetBottomRow: Array<Partial<VirtualKeyboardKeycap>> = [numberSwitchKey(), spaceKey, KEYCAPS.newLine]
const testPrepAlphaBottomRow: Array<Partial<VirtualKeyboardKeycap>> = [
  KEYCAPS.left,
  KEYCAPS.right,
  KEYCAPS[','],
  spaceKey,
  KEYCAPS['.'],
  KEYCAPS.newLine,
]

const panelKey = (
  keycap: Partial<VirtualKeyboardKeycap>,
  classNames = actionClassNames,
): Partial<VirtualKeyboardKeycap> => numpadKey({ ...keycap, class: classNames })

function panelKeyboard(
  label: string,
  extraKeys: Array<Partial<VirtualKeyboardKeycap>>,
  locale: AppLanguage,
  plainExtraKeys: Array<Partial<VirtualKeyboardKeycap>> = [],
): Readonly<VirtualKeyboardLayout> {
  const functionRow = [
    ...[KEYCAPS.divide, KEYCAPS.times, KEYCAPS['-'], KEYCAPS['+'], KEYCAPS['='], ...extraKeys].map((keycap) =>
      panelKey(keycap),
    ),
    ...plainExtraKeys.map((keycap) => panelKey(keycap, keyboardClassNames)),
  ]
  return {
    label,
    displayEditToolbar: false,
    layers: [
      {
        id: 'panelLayer',
        style: numpadLayerStyle({ id: 'panelLayer', rows: 3, columns: 10, divider: false }),
        rows: [
          functionRow,
          numericRow.map((keycap) => panelKey(keycap, keyboardClassNames)),
          [
            panelKey({ ...KEYCAPS['variable-switch'], width: 1 }),
            panelKey(KEYCAPS[','], keyboardClassNames),
            panelKey(KEYCAPS['.'], keyboardClassNames),
            panelKey(KEYCAPS.left),
            panelKey(KEYCAPS.right),
            numpadKey({ ...KEYCAPS.backspace, width: 2, class: `key-2x ${backspaceClassNames}` }),
          ],
        ],
      },
      alphabetLayer(locale, panelAlphabetBottomRow('panelLayer')),
    ],
  }
}

const DecimalNumbers_keyboard = (locale: AppLanguage): Readonly<VirtualKeyboardLayout> =>
  panelKeyboard('DecimalNumbers', [KEYCAPS['%']], locale)

const PowersRoots_keyboard = (locale: AppLanguage): Readonly<VirtualKeyboardLayout> =>
  panelKeyboard(
    'PowersRoots',
    [KEYCAPS.fraction, KEYCAPS.power, KEYCAPS.parenthesisOf, { ...KEYCAPS.squareRoot, label: '√' }, KEYCAPS['%']],
    locale,
  )

// Same grid as the numpad keyboards; the return key inserts a line break so
// multi-line test-prep answers stay possible.
const testPrepCommandRow = [
  numpadKey({ ...KEYCAPS['variable-switch'] }),
  numpadKey(KEYCAPS.left),
  numpadKey(KEYCAPS.right),
  numpadKey({ ...KEYCAPS.backspace }),
  numpadKey({ ...KEYCAPS.newLine, class: `${actionClassNames} !flex-1 !w-auto` }),
]

const TestPrep_keyboard = (locale: AppLanguage): Readonly<VirtualKeyboardLayout> => {
  const decimal = locale === AppLanguage.NO ? KEYCAPS[','] : KEYCAPS['.']
  return {
    label: 'TestPrepKeyboard',
    displayEditToolbar: false,
    layers: [
      {
        id: 'numpadLayer',
        style: numpadLayerStyle({ rows: 5, columns: 8, divider: true }),
        rows: [
          numpadGridRow([
            KEYCAPS.lessEqual,
            KEYCAPS.greaterEqual,
            KEYCAPS.lessThan,
            KEYCAPS.greaterThan,
            columnBorderSeparator,
            KEYCAPS['7'],
            KEYCAPS['8'],
            KEYCAPS['9'],
            KEYCAPS.divide,
          ]),
          numpadGridRow([
            KEYCAPS.plusMinus,
            KEYCAPS.log,
            KEYCAPS.sin,
            KEYCAPS.cos,
            columnBorderSeparator,
            KEYCAPS['4'],
            KEYCAPS['5'],
            KEYCAPS['6'],
            KEYCAPS.times,
          ]),
          numpadGridRow([
            KEYCAPS['%'],
            KEYCAPS.squareRoot,
            KEYCAPS.nthRoot,
            KEYCAPS.absoluteValue,
            columnBorderSeparator,
            KEYCAPS['1'],
            KEYCAPS['2'],
            KEYCAPS['3'],
            KEYCAPS['-'],
          ]),
          numpadGridRow([
            KEYCAPS.pi,
            KEYCAPS.parenthesisOf,
            KEYCAPS.fraction,
            KEYCAPS.power,
            columnBorderSeparator,
            decimal,
            KEYCAPS['0'],
            KEYCAPS['='],
            KEYCAPS['+'],
          ]),
          testPrepCommandRow,
        ],
      },
      alphabetLayer(locale, testPrepAlphabetBottomRow),
    ],
  }
}

const TestPrepAlpha_keyboard = (locale: AppLanguage): Readonly<VirtualKeyboardLayout> => ({
  label: 'TestPrepAlphaKeyboard',
  displayEditToolbar: false,
  layers: [alphabetLayer(locale, testPrepAlphaBottomRow)],
})
// Figma "keyboard" (299:14117): digits on top, +/-/./, and the controls below.
const NumericOnly_keyboard = (locale: AppLanguage): Readonly<VirtualKeyboardLayout> => ({
  label: 'NumericOnly',
  displayEditToolbar: false,
  layers: [
    {
      id: 'numpadLayer',
      style: numpadLayerStyle({ rows: 2, columns: 10, divider: false }),
      rows: [
        numericRow.map(numpadKey),
        [
          numpadKey(KEYCAPS['+']),
          numpadKey(KEYCAPS['-']),
          numpadKey(KEYCAPS['.']),
          numpadKey(KEYCAPS[',']),
          { ...KEYCAPS.separator, class: 'pointer-events-none !flex-1 !w-auto !bg-transparent' },
          numpadKey(KEYCAPS.left),
          numpadKey(KEYCAPS.right),
          numpadKey({ ...KEYCAPS.backspace, width: 1 }),
          checkKey(locale, '!w-20'),
        ],
      ],
    },
  ],
})

const Algebra_keyboard = (locale: AppLanguage): Readonly<VirtualKeyboardLayout> =>
  panelKeyboard('Algebra', [KEYCAPS['%']], locale, [KEYCAPS.normalX, KEYCAPS.normalY, KEYCAPS.normalZ])

const Compare_keyboard = (locale: AppLanguage): Readonly<VirtualKeyboardLayout> =>
  panelKeyboard(
    'Compare',
    [
      KEYCAPS['%'],
      KEYCAPS.colon,
      KEYCAPS.fraction,
      KEYCAPS.lessEqual,
      KEYCAPS.greaterEqual,
      KEYCAPS.lessThan,
      KEYCAPS.greaterThan,
    ],
    locale,
  )

// Oracle chat keyboard (Figma 442:14606): letters type text, the 123 / f(x) layers type math.
// Own layer ids: MathLive keeps a layer whose id the next layout shares, which would carry the Oracle's
// letters into the answer field (and the answer field's numbers into the Oracle).
const ORACLE_LAYER_IDS: Record<string, string> = {
  AlphabetLayer: 'OracleAlphabetLayer',
  panelLayer: 'OraclePanelLayer',
  numpadLayer: 'OracleNumpadLayer',
}

const oracleTextKey = (char: string): Partial<VirtualKeyboardKeycap> => {
  const upper = char.toUpperCase()
  return {
    label: char,
    command: ['insert', char, { mode: 'text' }],
    ...(upper !== char && { shift: { label: upper, command: ['insert', upper, { mode: 'text' }] } }),
    class: keyboardClassNames,
  }
}

const oracleMathKey = (keycap: Partial<VirtualKeyboardKeycap>): Partial<VirtualKeyboardKeycap> => {
  const latex = keycap.insert ?? keycap.latex ?? keycap.label
  if (keycap.command || !latex || latex.startsWith('[')) return keycap
  // A bare % starts a LaTeX comment and would insert nothing
  return { ...keycap, command: ['insert', latex === '%' ? '\\%' : latex, { mode: 'math' }] }
}

const oracleSendKey: Partial<VirtualKeyboardKeycap> = { ...KEYCAPS.return, class: `key-2x ${actionClassNames}` }

const oracleLayerSwitchKey = (label: string, targetLayer: string): Partial<VirtualKeyboardKeycap> => ({
  label,
  width: 1.5,
  command: ['switchKeyboardLayer', targetLayer],
  class: `key-2x ${actionClassNames}`,
})

const oracleAlphabetLayer = (locale: AppLanguage): VirtualKeyboardLayer => {
  const isNorwegian = locale === AppLanguage.NO
  return {
    id: ORACLE_LAYER_IDS.AlphabetLayer,
    style: numpadLayerStyle({
      id: ORACLE_LAYER_IDS.AlphabetLayer,
      rows: 5,
      columns: isNorwegian ? 11 : 10,
      divider: false,
      plateWidth: 680,
    }),
    rows: [
      [...'1234567890'].map(oracleTextKey),
      [...(isNorwegian ? 'qwertyuiopå' : 'qwertyuiop')].map(oracleTextKey).concat({
        ...KEYCAPS.backspaceSmall,
        class: `key-2x ${backspaceClassNames}`,
      }),
      [...(isNorwegian ? 'asdfghjkløæ' : 'asdfghjkl')].map(oracleTextKey).concat(oracleSendKey),
      [shiftKey, ...[...'zxcvbnm,.'].map(oracleTextKey), shiftKey],
      [
        oracleLayerSwitchKey('123', ORACLE_LAYER_IDS.panelLayer),
        oracleLayerSwitchKey('f(x)', ORACLE_LAYER_IDS.numpadLayer),
        { ...spaceKey, command: ['insert', ' ', { mode: 'text' }] },
        oracleTextKey('?'),
        oracleTextKey('!'),
      ],
    ].map(numpadGridRow),
  }
}

const oracleMathLayer = (layer: VirtualKeyboardLayer | string): VirtualKeyboardLayer => {
  const { rows = [], id = '', style = '', ...rest } = layer as VirtualKeyboardLayer
  const oracleId = ORACLE_LAYER_IDS[id] ?? id
  return {
    ...rest,
    id: oracleId,
    style: style.split(`#${id}`).join(`#${oracleId}`),
    rows: rows.map((row) =>
      row.map((keycap) => {
        if (typeof keycap === 'string') return keycap
        const { command } = keycap
        // TestPrep's line break key sends the message instead
        if (Array.isArray(command) && command[1] === '\\\\') return { ...oracleSendKey, class: keycap.class }
        // ABC goes back to the Oracle's letters
        if (Array.isArray(command) && command[0] === 'switchKeyboardLayer') {
          return { ...keycap, command: ['switchKeyboardLayer', ORACLE_LAYER_IDS[command[1]] ?? command[1]] }
        }
        return oracleMathKey(keycap)
      }),
    ),
  }
}

export const ORACLE_KEYBOARD_LABEL = 'Oracle'

export const OracleKeyboard = (locale: AppLanguage): Readonly<VirtualKeyboardLayout> => {
  const [decimalLayer] = (DecimalNumbers_keyboard(locale) as { layers: Array<VirtualKeyboardLayer | string> }).layers
  const [functionLayer] = (TestPrep_keyboard(locale) as { layers: Array<VirtualKeyboardLayer | string> }).layers
  return {
    label: ORACLE_KEYBOARD_LABEL,
    displayEditToolbar: false,
    layers: [oracleAlphabetLayer(locale), oracleMathLayer(decimalLayer), oracleMathLayer(functionLayer)],
  }
}

export const InAppKeyboardLayout = {
  DecimalNumbers_keyboard,
  PowersRoots_keyboard,
  Algebra_keyboard,
  Compare_keyboard,
  NumericOnly_keyboard,
  TestPrep_keyboard,
  TestPrepAlpha_keyboard,
  HoMCompact_keyboard,
} as const

export function resolveInAppKeyboardLayout(
  layoutId: keyof typeof InAppKeyboardLayout,
  locale: AppLanguage,
  desktop = false,
): Readonly<VirtualKeyboardLayout> {
  // A keyboardLayout document in Sanity can carry any layoutName string, so an
  // id this build does not know must fall back to the default layout.
  const knownId: keyof typeof InAppKeyboardLayout = InAppKeyboardLayout[layoutId] ? layoutId : 'DecimalNumbers_keyboard'
  if (desktop && knownId === 'NumericOnly_keyboard') {
    return panelKeyboard('NumericOnly', [], locale)
  }
  const layout = InAppKeyboardLayout[knownId]
  return typeof layout === 'function'
    ? (layout as (locale?: AppLanguage) => Readonly<VirtualKeyboardLayout>)(locale)
    : layout
}

let didApplyGlobalDefaultLayout = false

export function ensureDefaultVirtualKeyboardLayout(): void {
  if (didApplyGlobalDefaultLayout || typeof window === 'undefined' || !window.mathVirtualKeyboard) return
  didApplyGlobalDefaultLayout = true
  const lang = (document.documentElement.lang || AppLanguage.EN).slice(0, 2) as AppLanguage
  window.mathVirtualKeyboard.layouts = [resolveInAppKeyboardLayout('DecimalNumbers_keyboard', lang)]
}
